import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link as RLink } from "react-router-dom";
import Link from "@mui/material/Link";

import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { Page, selectPages } from "./pageSlice";
import { usePageQuery } from "../../api/page";
import MDViewer from "../markdown/Markdown";
import Metadata from "../metadata/Metadata";
import PageViewerToolBar from "./PageViewerToolBar";
import FileUploader from "../file/FileUploader";

export interface SerializedError {
    name?: string;
    message?: string;
    stack?: string;
    code?: string;
}

const vcontentStyle = {
    height: "100%",
    width: "100%",
    margin: 0,
    display: "flex",
    //backgroundColor: 'grey',
};
const contentStyle = {
    height: "100%",
    width: "100%",
    margin: 0,
    //overflow: 'auto',
    display: "flex",
    //backgroundColor: 'grey',
};
const colOneStyle = {
    height: "100%",
    flexGrow: 3,
    width: "75%",
    //backgroundColor: '#eeeeee',
    //overflow: 'auto',
};
const colTwoStyle = {
    height: "100%",
    flexGrow: 1,
    //backgroundColor: 'green',
    width: "25%",
    //overflow: 'auto',
};
const viewStyle = {
    height: `calc(100% - 44px)`,
    overflow: "auto",
    padding: 2,
    width: "100%",
    //height: '100%r',
    //backgroundColor: 'purple',
};

export function PageViewer() {
    let { pageId } = useParams();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    console.log("202409051528", pageId, isMobile);
    if (pageId) {
        if (isMobile) {
            return <PageViewerFetch pageId={pageId} />;
        } else {
            return <PageViewerFetch pageId={pageId} />;
        }
    } else {
        return <Box> Ho no, no page!</Box>;
    }
}

export function PageViewerFetch({ pageId }: { pageId: string }) {
    const dispatch = useAppDispatch();
    const {
        data: pageResult,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = usePageQuery(pageId, { refetchOnMountOrArgChange: true });

    return (
        <>
            {error ? (
                <PageViewerProblem error={error} isLoading={isLoading} />
            ) : isLoading ? (
                <PageViewerProblem error={error} isLoading={isLoading} />
            ) : pageResult ? (
                pageResult.page ? (
                    <PageViewerContent page={pageResult.page} />
                ) : (
                    <PageViewerProblem error={error} isLoading={isLoading} />
                )
            ) : null}
        </>
    );
}

export function PageViewerContent({ page }: { page: Page }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    if (isMobile) {
        return <MobilePageViewerContent page={page} />;
    } else {
        return <DesktopPageViewerContent page={page} />;
    }
}

export function DesktopPageViewerContent({ page }: { page: Page }) {
    return (
        <Box sx={vcontentStyle}>
            <Box>
                <PageViewerToolBar page={page} />
            </Box>
            <Box sx={contentStyle}>
                <Box sx={colOneStyle}>
                    <Box sx={{ height: 45 }}></Box>
                    <Box sx={viewStyle}>
                        <PageDisplay page={page} />
                    </Box>
                </Box>
                <Box sx={colTwoStyle}>
                    <Box sx={{ height: 45 }}></Box>
                    <Box sx={viewStyle}>
                        <Box>
                            <Metadata meta={page.metadata} />
                            ktype: {page.ktype}
                            {page.metadata.id && (
                                <FileUploader id={page.metadata.id} />
                            )}
                            <Link
                                component={RLink}
                                to={
                                    "/file/by-filter?page_id=" +
                                    page.metadata.id
                                }
                            >
                                {"Files"}
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export function MobilePageViewerContent({ page }: { page: Page }) {
    return (
        <Box sx={vcontentStyle}>
            <Box>
                <PageViewerToolBar page={page} />
            </Box>
            <Box sx={contentStyle}>
                <Box sx={{ height: 45 }}></Box>
                <Box sx={viewStyle}>
                    <PageDisplay page={page} />
                    <Metadata meta={page.metadata} />
                    ktype: {page.ktype}
                    {page.metadata.id && <FileUploader id={page.metadata.id} />}
                    <Link
                        component={RLink}
                        to={"/file/by-filter?page_id=" + page.metadata.id}
                    >
                        {"Files"}
                    </Link>
                </Box>
            </Box>
        </Box>
    );
}

export function PageViewerProblem({
    isLoading,
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
    isLoading: boolean;
}) {
    const dispatch = useAppDispatch();

    return (
        <Box sx={vcontentStyle}>
            <PageViewerToolBar page={null} />
            <Box sx={contentStyle}>
                <Box sx={colOneStyle}>
                    <Box sx={{ height: 45 }}></Box>
                    <Box sx={viewStyle}>
                        {error ? (
                            <Box>error</Box>
                        ) : isLoading ? (
                            <Box>Loading</Box>
                        ) : (
                            <Box>result but no page</Box>
                        )}
                    </Box>
                </Box>
                <Box sx={colTwoStyle}>
                    <Box sx={{ height: 45 }}></Box>
                    <Box sx={viewStyle}>
                        {error ? (
                            <Box>error</Box>
                        ) : isLoading ? (
                            <Box>Loading</Box>
                        ) : null}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

function PageDisplay({ page }: { page: Page }) {
    return (
        <Box sx={{ overflow: "auto", maxWidth: "1100px" }}>
            <Typography variant="title">{page.title}</Typography>
            <MDViewer md={page.content.content} />
        </Box>
    );
}

function testErrorType(error: FetchBaseQueryError | SerializedError) {
    console.log(error);
}
